import { render, staticRenderFns } from "./FixtenderSignUpOfPublicTender.vue?vue&type=template&id=f3445b24&scoped=true&"
import script from "./FixtenderSignUpOfPublicTender.vue?vue&type=script&lang=js&"
export * from "./FixtenderSignUpOfPublicTender.vue?vue&type=script&lang=js&"
import style0 from "./FixtenderSignUpOfPublicTender.vue?vue&type=style&index=0&id=f3445b24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3445b24",
  null
  
)

export default component.exports